import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-online-training',
  templateUrl: './online-training.component.html',
  styleUrls: ['./online-training.component.scss']
})
export class OnlineTrainingComponent implements OnInit {
  url: string ="https://www.getreliable.com/getreliable/login.aspx"
  contractCard:boolean=true;
  leadEmailInfo:any;
  stagesViews:any;
  isUploaddoc:boolean=false;
  leadId: string;
  error = '';
  isCompletedSA: boolean = false;
  isPendingSA: boolean = false;
  isInprogressSA: boolean = false;
  isPendingOT: boolean = false;
  isCompletedOT: boolean = false;
  isInprogressOT: boolean = false;
  titleNavOT:string="";
  personalinfo: any;
  contractUrl: any;
  contractDownloadUrl: any;
  contractId: any;
  contractFileUrl: any;
  checkedDoc: any;
  showbtn: any;
  signCard:boolean=true;
  iframemodel: boolean = false;
  document_hash;
  urlSafe: SafeResourceUrl;
  isInprogressUD: boolean = false;
  isCompleteddoc: boolean = true;
  isSignAgreement:boolean=false;
 isCompleted:boolean=false;
  constructor(private userservice:UserService,private router: Router) {

    this.leadEmailInfo= JSON.parse(sessionStorage.getItem('leadEmailInfo')) ;
    this.stagesViews= JSON.parse(sessionStorage.getItem('stagesViews'));
     if(this.stagesViews[1].isCompleted && this.stagesViews[1].isApproved ){
      if(this.stagesViews[1].isCompleted === true && this.stagesViews[1].isApproved===true){
        this.isUploaddoc = true;
        }
      
    }
   }

  ngOnInit(): void {
    this.leadEmailInfo= JSON.parse(sessionStorage.getItem('leadEmailInfo')) ;
    this.leadId=sessionStorage.getItem('leadId')
    this.getOnlineTrainingDetails();
    this.getDashboard();
    this.DocmoreInfoReq(this.leadId)  
  }
  goToGetReliable(){
    var win = window.open(this.url, '_blank');
    win.focus();
  }
showCard()
{
  this.contractCard=false;
  // this.authorizeUser();
}

link: any;
authorizeUser(){
    
  const email=this.leadEmailInfo;
  if(email){
   // console.log(email)
     return this.userservice.authorizeUser(email).pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.link = data.data.redirectPath;
         var win = window.open(this.link, '_blank');
          win.focus();
        }else{}
      },error=>{
       if(error.status == 400 || error.status==417){
             // this.error=error.error.data;
             }
          },()=>{});
  }
}
getDashboard() {
  this.userservice.getDashboardData().pipe()
    .subscribe(
      data => {
        this.personalinfo = data.data.leads;
        if (this.personalinfo.stagesViews != null || undefined) {
          sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))
          this.stagesViews=this.personalinfo.stagesViews;
          this.getContract();
        }
        if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === true) {
              
          this.isCompletedSA=true;
          this.titleNavOT=""
         }
         if (this.personalinfo.stagesViews[2].isCompleted === false && this.personalinfo.stagesViews[2].isApproved === false) {
           
           this.isPendingSA=true;
           //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"

         }
         if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === false) {

          
           this.isInprogressSA=true;
           //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
         }
         if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === true) {
          
           this.isCompletedOT=true;
         }
         if (this.personalinfo.stagesViews[3].isCompleted === false && this.personalinfo.stagesViews[3].isApproved === false) {
           
           this.isPendingOT=true;

         }
         if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === false) {

          
           this.isInprogressOT=true;
         }
         if(this.personalinfo.stagesViews[0].isCompleted === true &&
          this.personalinfo.stagesViews[0].isApproved === true   &&
       this.personalinfo.stagesViews[1].isCompleted === true &&
          this.personalinfo.stagesViews[1].isApproved === true   &&
       this.personalinfo.stagesViews[2].isCompleted === true &&
          this.personalinfo.stagesViews[2].isApproved === true   &&
      this.personalinfo.stagesViews[3].isCompleted === true &&
          this.personalinfo.stagesViews[3].isApproved === true)
          {
           this.router.navigate(['/activated']);
     }
        
      }, error => {
      }, () => { });
}
embeddedSigningUrl
getContract(){
  //var leadId=4;
  this.leadId=sessionStorage.getItem('leadId');
  this.userservice.getContractSignOFLead(this.leadId).pipe()
  .subscribe(
      data => {
          //
        if(data.data !==undefined){
          if (data.data[0].fileDownloadUrl != null) {
            if (data.data[0].files.length != 0) {
              // this.uploaddocs();
              // this.showExpiry = data.data.documents.expiryDate;
              // this.showDocumentName = data.data.documents.documentName;
              // this.showPolicyNumber = data.data.documents.policyNumber;
              // this.finalDocs = data.data.documents;
              this.contractFileUrl = data.data[0].fileUrl;
              this.contractId = data.data[0].files.id
              this.contractDownloadUrl = data.data[0].fileDownloadUrl;
              this.contractUrl = this.contractDownloadUrl.split('.').pop();
              this.checkedDoc = data.data[0].status
              // this.checkDocdesc=data.data.documents.description
            }
          }
          this.showbtn=this.personalinfo.stagesViews[2].isEditable
         if(this.stagesViews[1].isCompleted === true && this.stagesViews[1].isApproved===false){
          this.isUploaddoc = false;
          this.isCompleteddoc = true;
          this.isInprogressUD = true;
         }
          this.document_hash=data.data[0].documentHash;
          this.urlSafe="";
          if(data.data=="No contract Found" || data.success==false){
            this.signCard=true;
          }
          else{
            this.signCard=false;
            if(this.stagesViews[2].isCompleted && this.stagesViews[2].isApproved && data.data.fileUrl!=null){
              if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===true){
                this.isSignAgreement = true;
                this.isCompleted=true;
                }else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
                  this.isSignAgreement = true;
                  this.isCompleted=false;
                }
              this.urlSafe= data.data[0].fileUrl;
            }
            else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
              this.isSignAgreement = true;
              this.isCompleted=false;
            }
            
              this.signCard=false;
              let temp=data.data[0].signers
           let tempRole=temp.filter(itm=>itm.role=="Lead")
            if(tempRole.length>0){
    
              this.embeddedSigningUrl=tempRole[0].embeddedSigningUrl
              this.urlSafe= this.embeddedSigningUrl;
            
            }
            else{ this.urlSafe=""}
          
           
          }
          
      }
         },error=>{
     
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             
           }
           else{
             
             this.error="Something went wrong. Please check username and password.";
           }
           this.signCard=true;
          },()=>{});
}
getOnlineTrainingDetails(){
  this.userservice.getOnlineTrainingDetails(this.leadId).pipe()
  .subscribe(
    data => {
    // console.log(data);
    // for(let  i=0;i<data.data.length;i++)
    // {
      if (data.data.length > 0) {
      if(data.data[0].status === "Pending" &&
        data.data[1].status === "Pending"  &&
        data.data[2].status === "Pending" )
      {
      //  this.router.navigate(['/activated']);
       }
    else{
      
    }
  }


    }, error => {

      if (error.status == 400 || error.status == 417) {
        this.error = error.error.data;
      }
      else {
        this.error = "Something went wrong. Please check username and password.";
      }
    }, () => { });
  }
  DocmoreInfoReq(leadId){
    
    this.userservice.DocmoreInfoReq(leadId).pipe()
  .subscribe(
      data => {
        
          console.log(data.data);
          sessionStorage.setItem('DocmoreInfoReq', data.data)
      },error=>{
          },()=>{});
  }
}
